<template>
  <!-- Tool Bar -->
  <v-app-bar
    flat
    :color="background"
    extended
    extension-height="120px"
  >
    <v-container>
      <v-layout
        row
        justify-center
        align-center
        class="ma-0"
      >
        <!-- Logo -->
        <v-toolbar-title>
          <router-link :to="backHome">
            <v-img
              :src="`${require('@/assets/images/logo/logo.svg')}`"
              aspect-ratio="1"
              contain
              width="120"
              max-width="120"
              max-height="40"
              class="text-center logo"
            ></v-img>
          </router-link>
          <svg class="svg" viewBox="0 0 250 185" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Artboard" transform="translate(-1.000000, -1.000000)" fill="#712A7A">
                      <path d="M79.9741874,1 C40.3619796,1 1,31.347638 1,82.1039244 C1,131.30137 45.834361,161.925399 84.7829201,161.925399 C127.691612,161.925399 148.373515,148.249614 184.515166,155.690037 C212.78007,161.483174 228.043989,175.534849 235.63787,182.886827 C239.249859,186.424621 243.862761,186.822623 247.006933,184.711002 C250.140225,182.610437 252.272604,178.630419 250.140225,169.100487 C245.211818,146.945053 233.592527,122.136273 220.112844,100.986899 C193.610417,59.39571 139.843998,1 79.9741874,1" id="Fill-36"></path>
                  </g>
              </g>
          </svg>
        </v-toolbar-title><!-- Logo -->
        <v-spacer></v-spacer>

        <!-- <v-btn
          v-if="isAuthenticated"
          @click.stop="drawer = !drawer"
        >
          <v-icon>side-icon</v-icon>
          burger
        </v-btn> -->

        <!-- Non Authenticated User Menu -->
        <NotAuthenticatedUserMenu
          v-if="!isAuthenticated"
        ></NotAuthenticatedUserMenu>

        <!-- Authenticated User Menu -->
        <AuthenticatedUserMenu
          v-else-if="isAuthenticated && !isMobile"
        ></AuthenticatedUserMenu>

        <!-- Profile Dropdown Menu -->
        <ProfileDropdown
          v-if="isAuthenticated"
          class="ml-3"
          :isMobile="isMobile"
        ></ProfileDropdown>

        <!-- Check if the user is logged -->

      </v-layout>
    </v-container>
  </v-app-bar>
</template>

<script>
import NotAuthenticatedUserMenu from './NotAuthenticatedUserMenu'
import AuthenticatedUserMenu from './AuthenticatedUserMenu'
import ProfileDropdown from './ProfileDropdown'

export default {
  data () {
    return {
      background: '#1a182a',
      color: '#1a182a',
      drawer: false,

      isMobile: false
    }
  },
  
  components: {
    NotAuthenticatedUserMenu: NotAuthenticatedUserMenu,
    AuthenticatedUserMenu: AuthenticatedUserMenu,
    ProfileDropdown: ProfileDropdown
  },

  computed: {
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    backHome () {
      if(this.isAuthenticated) return '/dashboard'
      else return '/'
    }
  },


  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 960
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header { overflow: hidden; }
.v-toolbar__title {
  position: relative;
  overflow: visible;
}
.svg {
  position: absolute;
  top: -80px; left: -40px;
  z-index: -1;
  width: 450px;
  g {
    width: 100%;
  }
}
.logo { border-radius:0 !important; }
</style>
